<template>
  <ModalInformation
    :show="props.show"
    @close="emit('close')"
    title="Sync to Calendar"
  >
    <LoadingSpinner v-if="!syncMyTripsUrl || !syncAllTripsUrl" />
    <template v-else>
      <div class="space-y-4">
        <div>
          <ButtonBase
            :leadingIcon="RefreshIcon"
            :href="syncAllTripsUrl"
            external
            >Sync All Trips</ButtonBase
          >
          <ParagraphText class="mt-2"
            >Click this button to sync all trips from
            {{ props.plane.tail_number }} with your calendar app.</ParagraphText
          >
        </div>
        <div>
          <ButtonBase :leadingIcon="RefreshIcon" :href="syncMyTripsUrl" external
            >Sync My Trips</ButtonBase
          >
          <ParagraphText class="mt-2"
            >Click this button to sync only your trips from
            {{ props.plane.tail_number }} with your calendar app.</ParagraphText
          >
        </div>
        <InputHelpText
          >All past and future trips will be synced. When new trips are added,
          they may take from a few minutes to 24 hours to show up in your
          calendar app, depending on your calendar refresh
          settings.</InputHelpText
        >
      </div>
    </template>
  </ModalInformation>
</template>

<script setup>
import ModalInformation from '@/Common/Overlays/Modals/ModalInformation.vue'
import axios from 'axios'
import { ref, watch } from 'vue'
import LoadingSpinner from '@/Common/Elements/LoadingSpinner.vue'
import ButtonBase from '@/Common/Elements/Buttons/ButtonBase.vue'
import InputHelpText from '@/Common/Forms/Inputs/InputHelpText.vue'
import { RefreshIcon } from '@heroicons/vue/solid'
import ParagraphText from '@/Common/Text/ParagraphText.vue'

const props = defineProps({
  show: Boolean,
  plane: Object,
})

const emit = defineEmits(['close'])

const syncMyTripsUrl = ref(null)
const syncAllTripsUrl = ref(null)

watch(
  () => props.show,
  () => {
    if (props.show) {
      axios.get(route('planes.calendar', props.plane)).then((response) => {
        syncMyTripsUrl.value = response.data.syncMyTripsUrl
        syncAllTripsUrl.value = response.data.syncAllTripsUrl
      })
    }
  }
)
</script>
